import type { SortField } from "../../../../../../../../api/types/svTypes.ts";
import type { PivotColumnMetadataLookup } from "../../../viewer/pivot/utils/pivotColumnMetadata.ts";
import { pivotSortableAggregationTypes } from "../../../viewer/pivot/utils/rebuildPivotSortingFields.ts";

export const getPivotSortFilterMap = (
  field: SortField,
  pivotColumnMetadataLookup: PivotColumnMetadataLookup,
  dimensionCaptionsMap: Record<string, string>
): Array<[string, string]> => {
  if (!pivotSortableAggregationTypes.includes(field.config.type) || !field.config.pivotColumnId) {
    return [];
  }

  const pivotColumnMetadata = pivotColumnMetadataLookup[field.config.pivotColumnId];
  if (!pivotColumnMetadata) {
    return [];
  }

  return Object.entries(pivotColumnMetadata.filters).map(([key, value]) => [dimensionCaptionsMap[key] ?? key, value]);
};
